import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      flexWrap: 'wrap',
      margin: '30px 0'
    },
    loadingContainer: {
      margin: '30px 0'
    },
    btnContainer: {
      width: '100%',
      padding: '10px 0',
      '& > button': {
        width: 'inherit'
      },
      '@media (min-width: 1280px)': {
        display: 'none'
      }
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
